import getBilling from './getBilling';
import storeCard from './storeCard';
import changeCard from './changeCard';
import deleteCard from './deleteCard';

export default {
  getBilling,
  storeCard,
  changeCard,
  deleteCard
}



// WEBPACK FOOTER //
// ./src/app/services/user-billing/index.js